export default class SellingPlan {
  id!: string;
  name!: string;

  constructor(response?: any) {
    if (response != null) {
      this.id = response.id;
      this.name = response.name;
    }
  }
}
